import { Divider } from 'antd';
import { IReportType } from '../../../../types/reports';
import styles from '../Reports.module.scss';
import { ReportNavigationButton } from './ReportNavigationButton';
interface ReportsNavigationProps {
  availableReports: IReportType[];
  activeReport: string | null;
  handleReportTypeChanged: (report: IReportType) => void;
}

const ReportsNavigation = ({
  availableReports,
  activeReport,
  handleReportTypeChanged,
}: ReportsNavigationProps) => {
  const [onDemandReports, preprocessedReports] = availableReports.reduce<
    [IReportType[], IReportType[]]
  >(
    (acc, report) => {
      if (report.category === 'on-demand') {
        acc[0].push(report);
      } else if (report.category === 'pre-processed') {
        acc[1].push(report);
      }

      return acc;
    },
    [[], []]
  );

  return (
    <div className={styles.reportsNavigation}>
      <div>
        <Divider className={styles.reportsNavigationDivider}>
          <span className={styles.dividerText}>On demand</span>
        </Divider>
        {onDemandReports.map((item) => {
          const id = item.id.replace(/\s+/g, '');

          return (
            <ReportNavigationButton
              reportItem={{ ...item, id }}
              isActive={item.id === activeReport}
              handleReportTypeChanged={handleReportTypeChanged}
              key={id}
            />
          );
        })}
      </div>
      <div>
        <Divider className={styles.reportsNavigationDivider}>
          <span className={styles.dividerText}>Preprocessed</span>
        </Divider>
        {preprocessedReports.map((item) => {
          const id = item.id.replace(/\s+/g, '');

          return (
            <ReportNavigationButton
              reportItem={{ ...item, id }}
              isActive={item.id === activeReport}
              handleReportTypeChanged={handleReportTypeChanged}
              key={id}
              showIcon
            />
          );
        })}
      </div>
    </div>
  );
};

export default ReportsNavigation;
